import { PresentationEventTypes } from './event-manager/event-types';
import type { IEventManager } from './event-manager';

export class TransactionManager {
    private runningTxCount = 0;

    constructor(public events: IEventManager) {
        this.init();
    }

    private init = () => {
        this.events.on(PresentationEventTypes.RequestBeginTransaction, this.onTransactionBegin);
        this.events.on(PresentationEventTypes.RequestEndTransaction, this.onTransactionEnd);
        this.events.on(PresentationEventTypes.EnqueueMutations, this.onEnqueueMutations);
        return this;
    };

    private onTransactionBegin = () => {
        this.events.emit(PresentationEventTypes.BeginTransaction, this.runningTxCount);
        this.runningTxCount += 1;
    };

    private onTransactionEnd = () => {
        this.runningTxCount -= 1;
        this.events.emit(PresentationEventTypes.EndTransaction, this.runningTxCount);
        this.commitTransactionIfNeeded();
    };

    private onEnqueueMutations = () => {
        this.commitTransactionIfNeeded();
    };

    private commitTransactionIfNeeded = () => {
        if (this.runningTxCount <= 0) {
            try {
                this.events.emit(PresentationEventTypes.CommitTransaction);
            } catch (err) {
                throw err;
            } finally {
                this.runningTxCount = 0;
            }
        }
    };
}
